module.exports = __webpack_public_path__ + "static/img/icon7-5.b1ed665e.png";